"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselHeaderMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
/** @class CarouselHeaderMixin */
/** @method */
var CarouselHeaderMixin = function CarouselHeaderMixin(props) {
  return (0, _styledToken.default)({
    gridGap: 'CarouselHeader.gridGap',
    paddingBottom: 'CarouselHeader.paddingBottom'
  }, function (_ref) {
    var gridGap = _ref.gridGap,
      paddingBottom = _ref.paddingBottom;
    return (0, _styledComponents.css)(["align-items:center;display:grid;grid-auto-flow:column;grid-gap:", ";justify-content:space-between;padding-bottom:", ";"], gridGap ? gridGap + "px" : (0, _spaceMixin.spaceMixin)('lg')(props), paddingBottom ? paddingBottom + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.CarouselHeaderMixin = CarouselHeaderMixin;